import _ from 'underscore';
import {
  createRequestContract,
  createResponseContract,
  createSpec,

  requestVerbs,
  responseTypes,
  specTypes,
} from '@bingads-webui-react/overreact';

import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../../env/edm';
import { environmentLookupFn } from '../../../../../../env/env-instance';
import { schema } from '../../../../../../env/schema';

import {
  headerDecorator,
  sideEffects,

  networkPolicy,
} from './add-decorators';

function odataUrlFactory(params) {
  const { variables } = params;
  const { locator: { descriptor } } = variables;
  const {
    customer_id: CustomerId,
    account_id: AccountId,
  } = descriptor;

  const edmEntity = edm
    .Customers.$withKey(CustomerId)
    .Accounts.$withKey(AccountId)
    .Tags;

  const searchString = composeSearchString(variables, edmEntity);
  return `${edmEntity.path}${searchString}`;
}

function odataHeaderFactory(params) {
  return params.headers;
}

function odataPayloadFactory(params) {
  return params.data;
}

const requestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:tag',
  verb: requestVerbs.POST,
  fetchPolicy: networkPolicy,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: headerDecorator(odataHeaderFactory),
  payloadFactoryFn: odataPayloadFactory,
  keySelector: variables => variables.locator.descriptor.tag_id,
  parentKeySelector: variables => variables.locator.descriptor.account_id,
});

const responseContract = createResponseContract({
  requestContract,
  responseType: responseTypes.ENTITY,
  keySelector: _.identity,
  processorFn: _.identity,
});

export const addSpec = createSpec(
  requestContract,
  responseContract,
  specTypes.ADD,
  sideEffects.add,
  environmentLookupFn
);
